
import { defineComponent, ref, reactive, toRefs, onMounted, watch, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Drawer from '@/components/drawer.vue'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Drawer, Charts, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      radiovalue: '',
      pagination: {
        showSizeChanger: true,
        showTotal: (total: any) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showQuickJumper: true
      },
      option: {},
      visible: false,
      radiolist: [],
      spinning: true
    })
    const color = globalsets.getColor()
    pageData.columns = [
      {
        title: '机构类型',
        dataIndex: 'type',
        key: 'type',
        width: '80px'
      },
      {
        title: '持股家数',
        dataIndex: 'SumHoldN',
        key: 'SumHoldN',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '持股数(股)',
        dataIndex: 'HoldSum',
        key: 'HoldSum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占总流通股本比例',
        dataIndex: 'PCTOfTotalShares',
        key: 'PCTOfTotalShares',
        width: '120px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '占总股本比例',
        dataIndex: 'ShareCapitalPercentage',
        key: 'ShareCapitalPercentage',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      }
    ]
    pageData.data = [
      {
        index: 1,
        name: '周琴',
        gdxz: '个人',
        gdlx: 'A股',
        cgs: 64364345354,
        gdrs: 67,
        zj: 2423425,
        bl: 0.67
      },
      {
        index: 2,
        name: '廖应宽',
        gdxz: '个人',
        gdlx: 'A股',
        cgs: 64364345354,
        gdrs: 67,
        zj: -2423425,
        bl: -0.67
      },
      {
        index: 3,
        name: '廖应宽',
        gdxz: '个人',
        gdlx: 'A股',
        cgs: 64364345354,
        gdrs: 67,
        zj: -2423425,
        bl: -0.67
      },
      {
        index: 4,
        name: '廖应宽',
        gdxz: '个人',
        gdlx: 'A股',
        cgs: 64364345354,
        gdrs: 67,
        zj: -2423425,
        bl: -0.67
      },
      {
        index: 5,
        name: '廖应宽',
        gdxz: '个人',
        gdlx: 'A股',
        cgs: 64364345354,
        gdrs: 67,
        zj: -2423425,
        bl: -0.67
      }
    ]
    function setData() {
      const data = JSON.parse(JSON.stringify((props.pageSourceData || {}).AgentHold))
      const currentdata: any = data.filter((item: any) => window.moment(item.EndData * 1000).format('YYYY-MM-DD') === pageData.radiovalue)
      const _data = currentdata[0].Detail
      let list: any = []

      list = [
        {
          index: 'AgentHold1',
          type: '基金',
          SumHoldN: _data.FundsHoldingsTNum,
          HoldSum: _data.FundsHoldingsT,
          PCTOfTotalShares: _data.FundsHoldingsTPropCircul,
          ShareCapitalPercentage: _data.FundsHoldingsTPropTotal
        },
        {
          index: 'AgentHold2',
          type: 'QFII',
          SumHoldN: _data.QFIIHoldingsNum,
          HoldSum: _data.QFIIHoldings,
          PCTOfTotalShares: _data.QFIIHoldPropCircul,
          ShareCapitalPercentage: _data.QFIIHoldPropTotal
        },
        {
          index: 'AgentHold3',
          type: '社保',
          SumHoldN: _data.SocialSecuHoldN,
          HoldSum: _data.SocialSecuHold,
          PCTOfTotalShares: _data.SocialSecuHoldPropCircul,
          ShareCapitalPercentage: _data.SocialSecuPropTotal
        },
        {
          index: 'AgentHold4',
          type: '其他机构',
          SumHoldN: _data.OtherHoldN,
          HoldSum: _data.OtherHold,
          PCTOfTotalShares: _data.OtherHoldPropCircul,
          ShareCapitalPercentage: _data.OtherPropTotal
        },
        {
          index: 'AgentHold5',
          type: '合计',
          SumHoldN: _data.SumHoldN,
          HoldSum: _data.SumHold,
          PCTOfTotalShares: _data.SumHoldPropCircul,
          ShareCapitalPercentage: _data.SumPropTotal
        }
      ]
      pageData.data = list
      setoption()
    }
    let textStyle = {
      color: '#4D4D4D'
    }
    if (props.theme === 'dark') {
      textStyle = {
        color: '#D7D7DF'
      }
    }
    function setoption() {
      const data = JSON.parse(JSON.stringify(pageData.data))
      const ShareCapitalPercentage = data[4].ShareCapitalPercentage
      const _data = data.slice(0, 4)
      _data.push({
        type: '非机构持仓',
        ShareCapitalPercentage: 100 - ShareCapitalPercentage
      })

      pageData.option = {
        color: ['#0060FF', '#00D894', '#00E1FF', '#FF9300', '#FF469D'],
        tooltip: {
          trigger: 'item',
          position: 'right',
          formatter: function(params: any) {
            const { data, color } = params
            // '{b}<br /> <i style="width: 10px;height: 10px;border-radius: 50%;"></i>比例： {d}%'
            return `<div class="optiontooltip"><p>${
              data.name
            }</p> <div style="width: 10px;height: 10px;border-radius: 50%;display:inline-block;background-color: ${color}"></div> 比例： ${data.value.toFixed(
              2
            )}%</div>`
          }
        },
        legend: {
          orient: 'vertical',
          left: 180,
          top: 36,
          bottom: 20,
          icon: 'circle',
          selectedMode: false,
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 20,
          textStyle: textStyle
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '60%',
            center: [80, ' 50%'],
            data: _data.map((item: any) => ({ name: item.type, value: item.ShareCapitalPercentage })),
            labelLine: {
              show: false
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
    function changeradio() {
      setData()
    }
    watch(
      () => (props.pageSourceData || {}).AgentHold,
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val))
        if ((data || []).length) {
          pageData.radiolist = data.map((item: any) => window.moment(item.EndData * 1000).format('YYYY-MM-DD'))
          pageData.radiovalue = pageData.radiolist[0]
          setData()
        }
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData),
      changeradio
    }
  }
})
